import React from 'react'

import { Col, Icon, Tooltip, Button } from 'antd'

import { toTestId } from '../../../../../../utils/testing'

export default function SkillSorterColumn(props) {
  const { skillSortOption, setSelectedSkillsFilter, isActiveTab = true, ...rest } = props
  const { displayName, propertyName, color, iconType, description } = skillSortOption

  return (
    <Col md={6} {...rest}>
      <Button
        type="link"
        onClick={() => setSelectedSkillsFilter(propertyName)}
        disabled={!isActiveTab}
        tabIndex={isActiveTab ? 0 : -1}
        data-testid={`${toTestId(displayName)}-column-sort`}
        aria-label={`Sort by ${displayName}`}
        style={{ border: 'none', height: 'auto', padding: 0 }}
      >
        <Tooltip placement="top" title={description}>
          <Icon
            type={iconType}
            style={{
              color,
              fontSize: 18,
              opacity: 0.8,
              verticalAlign: 0,
            }}
          />
          <span className="legend-label">{displayName}</span>
        </Tooltip>
      </Button>
    </Col>
  )
}
